export default __webpack_public_path__ + "static/media/promo.d1ae9280.gif";